import { SET_CONFIG } from "../actions/types";

const initialConfig = {
  appIdentityProviders: {},
  appImageConfig: [],
  attributeDataTypes: [],
  awsRegions: [],
  compressionFormats: [],
  defaultCluster: "VORTEX_WH",
  defaultSchema: "PROJECT",
  defaultSourceValues: {
    type: "csv",
    delimiter: ",",
    qualifier: '"',
    encoding: "UTF8",
    compression: "auto",
    errorAction: "ABORT_STATEMENT",
  },
  delimiters: [],
  dqmAlerts: [],
  dqmCharsets: [],
  enclosedByOptions: [],
  encodingTypes: [],
  errorActions: [],
  explorerDefaultLimit: 10,
  fileTypes: [],
  fileUploadChunkSizeInMB: "50",
  mysqlRestrictedColumnNames: [],
  nullValues: [],
  numberOfOpenThreads: 10,
  previewCount: 100,
  restrictedColumnNames: [],
  s3FileUploadChunkSizeInMB: "50",
  salesforceDelimiters: [],
  showEnforceDataVault: true,
  disablePassBasedUser: true,
  timezone: "UTC",
};

//Handling User
export const configReducer = (state = initialConfig, { type, payload }) => {
  switch (type) {
    case SET_CONFIG:
      return {
        ...state,
        ...payload.config,
        ...(payload?.config?.defaultSourceValues
          ? {
              defaultSourceValues: {
                ...state.defaultSourceValues,
                ...payload.config.defaultSourceValues,
              },
            }
          : {}),
      };
    default:
      return state;
  }
};
